import './header.css';
import { useState} from "react";
import { useNavigate } from 'react-router-dom';

export const Header = () => {
  const navigate = useNavigate();
  const handleNavi=(page:string)=>{
    setSpMenu(0);
    setShopList(0);
    setSpShopList(0);
    if(page === "contents"){
      navigate({ pathname: "/contents" });
    }
    else if(page === "info"){
      navigate({ pathname: "/news" });
    }
    else if(page === "work"){
      navigate({ pathname: "/work" });
    }
    else if(page === "products"){
      navigate({ pathname: "/products" });
    }
    else if(page === "company"){
      navigate({ pathname: "/company" });
    }
    else if(page === "reclute"){
      navigate({ pathname: "/reclute" });
    }
    else if(page === "onlineshop"){
      navigate({ pathname: "/shop" });
    }
    else{
      navigate({ pathname: "/" });
    } 
  }

  const [spMenu, setSpMenu] = useState<number>(0);
  const [shopList, setShopList] = useState<number>(0);
  const [spShopList, setSpShopList] = useState<number>(0);
  const openShopList   = () => { shopList === 1 ? setShopList(0) : setShopList(1);};
  const openSpMenu     = () => { spMenu === 1 ? setSpMenu(0)   : setSpMenu(1);};
  const openSpShopList = () => { spShopList === 1 ? setSpShopList(0) : setSpShopList(1);};

  return (
    <>
      <header>
        <div className = 'header-box' >
          
          <div className = "header-logo-box" onClick={() => handleNavi("home")}>
            <img src='img/logo.png' alt= "有限会社 野村製作所 | 革製品OEM" />
            <h1>野村製作所</h1>
          </div>
          <div className='header-menu-icon-box'>
            <img src='img/menu.png' onClick={openSpMenu} alt='menu' />
          </div>
          <div className = 'header-menu-box'>
            <ul>
              <li><div className = 'header-menu-tab-box' onClick={() => handleNavi("info")}><h2>NEWS</h2><p>お知らせ</p></div></li>
              <li><div className = 'header-menu-tab-box' onClick={() => handleNavi("work")}><h2>WORK</h2><p>私達のできること</p></div></li>
              <li><div className = 'header-menu-tab-box' onClick={() => handleNavi("products")}><h2>PRODUCTS</h2><p>商品を見る</p></div></li>
              <li><div className = 'header-menu-tab-box' onClick={() => handleNavi("company")}><h2>COMPANY</h2><p>会社を知る</p></div></li>
              <li><div className = 'header-menu-tab-box' onClick={() => handleNavi("reclute")}><h2>RECRUIT</h2><p>一緒に働く</p></div></li>
            </ul>
            <div className='btn-box' onClick={() => handleNavi("onlineshop")}>
              <img src='img/shop.png' alt='shop'  />
              <div className='btn-title' >
                <h2>ONLINE SHOP</h2>
                <p>お買い物をする</p>
              </div>
            </div>
            
          </div>

          {/* スマホメニュー */}
          {spMenu === 1 ? 
            <div className = 'sp-header-menu-box'>
              <div className='sp-header-control'><img src='img/close.png' onClick={openSpMenu} /></div>
              <ul>
                <li><div className = 'sp-header-menu-tab-box' onClick={() => handleNavi("info")}><h2>NEWS</h2><p>お知らせ</p></div></li>
                <li><div className = 'sp-header-menu-tab-box' onClick={() => handleNavi("work")}><h2>WORK</h2><p>私達のできること</p></div></li>
                <li><div className = 'sp-header-menu-tab-box' onClick={() => handleNavi("products")}><h2>PRODUCTS</h2><p>商品を見る</p></div></li>
                <li><div className = 'sp-header-menu-tab-box' onClick={() => handleNavi("company")}><h2>COMPANY</h2><p>会社を知る</p></div></li>
                <li><div className = 'sp-header-menu-tab-box' onClick={() => handleNavi("reclute")}><h2>RECLUTE</h2><p>一緒に働く</p></div></li>
              </ul>
              <div className='sp-btn-box' onClick={() => handleNavi("onlineshop")}>
                <img src='img/shop.png' alt='shop' />
                <div className='sp-btn-title'>
                  <h2>ONLINE SHOP</h2>
                  <p>お買い物をする</p>
                </div>
              </div>
              <div className='header-sns-btn' >
                  <a href="https://www.instagram.com/nomuraseisakusho_official/" target="_blank" rel="noopener"><img src='img/instagram.png' alt='instagram'/></a>
                  <a href="https://www.facebook.com/nomuraseisakusho/" target="_blank" rel="noopener"><img src='img/facebook.png' alt='facebook' /></a>
                  <a href="https://x.com/nomurass_jp" target="_blank" rel="noopener"><img src='img/twitter_x.png' alt='twitter_x'/></a>
              </div>
            </div>
            : null
          }
        </div>
      </header>
    </>
  );
};
